var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#2C989C",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.96 8.844c0 2.083-1.006 3.046-3.036 3.046a.46.46 0 0 0-.434.434.434.434 0 0 0 .434.434c2.039 0 3.01.972 3.037 3.046a.434.434 0 1 0 .868 0c0-2.091.937-3.046 3.037-3.046a.443.443 0 0 0 .434-.425.434.434 0 0 0-.408-.434c-2.091-.104-3.063-1.059-3.063-3.011a.434.434 0 0 0-.868-.044ZM9.2 13.941a.364.364 0 0 0-.729 0c0 1.014-.474 1.458-1.458 1.458a.372.372 0 0 0-.364.365.364.364 0 0 0 .364.364c.992 0 1.458.452 1.458 1.458a.365.365 0 0 0 .729 0c0-1.006.437-1.458 1.457-1.458a.372.372 0 0 0 .365-.357.366.366 0 0 0-.365-.372c-1.005-.05-1.457-.495-1.457-1.457ZM8.303 6.322c0 1.51-.703 2.178-2.17 2.178a.434.434 0 1 0 0 .868c1.485 0 2.17.677 2.17 2.178a.434.434 0 0 0 .868 0c0-1.5.668-2.178 2.17-2.178a.442.442 0 0 0 .434-.425.434.434 0 0 0-.417-.434c-1.51-.087-2.187-.746-2.187-2.16a.434.434 0 0 0-.425-.435.443.443 0 0 0-.443.408Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.e61ebf87f9390b0078d365a60d73a054.svg";
export { ForwardRef as ReactComponent };